
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M512 255.1a8.053 8.053 0 01-2.344 5.691l-80 88C428.1 351.2 426 352 424 352c-4.3 0-8-3.4-8-8 0-2.047.781-4.094 2.344-5.656L484.7 264H264v220.7l74.34-66.34c1.56-1.56 2.76-2.36 5.66-2.36 2.906 0 8 2.281 8 8a7.946 7.946 0 01-2.344 5.656l-88 80A8.123 8.123 0 01256 512c-2 0-4.094-.781-5.656-2.344l-88-80A8.123 8.123 0 01160 424c0-4.6 3.7-8 8-8 2.047 0 4.094.781 5.656 2.344L248 484.7V264H27.31l66.34 74.34C95.22 339.9 96 341.1 96 344c0 2.9-2.28 8-8 8a7.946 7.946 0 01-5.656-2.344l-80-88C.781 260.1 0 258 0 255.1s.781-4.059 2.344-5.622l80-88C83.91 160.8 85.95 160 88 160c4.26 0 8 3.4 8 8a7.972 7.972 0 01-2.344 5.656L27.31 248H248V27.31l-74.3 66.35A8.228 8.228 0 01168 96c-2.9 0-8-2.28-8-8 0-2.062.781-4.094 2.344-5.656l88-80C251.9.781 253.1 0 256 0s4.094.781 5.656 2.344l88 80A8.053 8.053 0 01352 88c0 4.57-3.7 8-8 8a7.972 7.972 0 01-5.656-2.344L264 27.31V248h220.7l-66.34-74.34A8.087 8.087 0 01416 168c0-2.9 2.3-8 8-8 2.062 0 4.094.781 5.656 2.344l80 88C511.2 251.9 512 253.9 512 255.1z"}})])
          )
        }
      }
    